import types from '../types'

const initialState = {
  userFriendlyStatus: '',
  getPatient: {
    loading: true,
    success: false,
    error: false,
    data: []
  },
  patient: [],
  getEncounter: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
  encounter: null,
  startEncounterOver: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
  getMedications: {
    loading: false,
    success: false,
    error: false,
  },
  medications: [],
  getProcedures: {
    loading: false,
    success: false,
    error: false,
  },
  procedures: [],
  getObservations: {
    loading: false,
    success: false,
    error: false
  },
  observations: [],
  getConditions: {
    loading: false,
    success: false,
    error: false
  },
  conditions: [],
  reset: {
    loading: false,
    success: false,
    error: false
  }
}

const patientReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.GET_PATIENT_REQUESTED: {
    return {
      ...state,
      userFriendlyStatus: 'Retrieving patient information...',
      getPatient: {
        loading: true,
        success: false,
        error: false,
        data: []
      }
    }
  }
  case types.GET_PATIENT_FULFILLED: {
    const { firstName, middleName, lastName, mrn } = action.payload
    return {
      ...state,
      userFriendlyStatus: `Patient Found: ${firstName} ${middleName || ''} ${lastName} MRN: ${mrn}`,
      getPatient: {
        ...state.getPatient,
        loading: false,
        success: true,
        data: action.payload
      },
      patient: action.payload
    }
  }
  case types.GET_PATIENT_REJECTED: {
    return {
      ...state,
      getPatient: {
        ...state.getPatient,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_ENCOUNTER_REQUESTED: {
    const patient = state.patient
    return {
      ...state,
      userFriendlyStatus: `Retrieving encounter for ${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`,
      getEncounter: {
        ...state.getEncounter,
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
  }
  case types.GET_ENCOUNTER_FULFILLED: {
    const { encounter } = action.payload
    return {
      ...state,
      getEncounter: {
        ...state.getEncounter,
        loading: false,
        success: true,
        data: encounter
      },
      encounter
    }
  }
  case types.GET_ENCOUNTER_REJECTED: {
    return {
      ...state,
      getEncounter: {
        ...state.getEncounter,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_PATIENT_CONDITIONS_REQUESTED: {
    const patient = state.patient
    return {
      ...state,
      userFriendlyStatus: `Retrieving reported conditions for ${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`,
      getConditions: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.GET_PATIENT_CONDITIONS_FULFILLED: {
    const patient = state.patient
    return {
      ...state,
      userFriendlyStatus: `Found conditions for ${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`,
      getConditions: {
        ...state.getConditions,
        loading: false,
        success: true
      },
      conditions: action.payload
    }
  }
  case types.GET_PATIENT_CONDITIONS_REJECTED: {
    return {
      ...state,
      getConditions: {
        ...state.getConditions,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_PATIENT_PROCEDURES_REQUESTED: {
    const patient = state.patient
    return {
      ...state,
      userFriendlyStatus: `Retrieving procedures for ${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`,
      getProcedures: {
        loading: true,
        error: false,
        success: false
      }
    }
  }
  case types.GET_PATIENT_PROCEDURES_FULFILLED: {
    const patient = state.patient
    return {
      ...state,
      userFriendlyStatus: `Found procedures for ${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`,
      getProcedures: {
        ...state.getProcedures,
        loading: false,
        success: true
      },
      procedures: action.payload
    }
  }
  case types.GET_PATIENT_PROCEDURES_REJECTED: {
    return {
      ...state,
      getProcedures: {
        ...state.getProcedures,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_PATIENT_OBSERVATIONS_REQUESTED: {
    const patient = state.patient
    return {
      ...state,
      userFriendlyStatus: `Retrieving observations for ${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`,
      getObservations: {
        loading: true,
        error: false,
        success: false
      }
    }
  }
  case types.GET_PATIENT_OBSERVATIONS_FULFILLED: {
    const patient = state.patient
    return {
      ...state,
      userFriendlyStatus: `Found observations for ${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`,
      getObservations: {
        ...state.getObservations,
        loading: false,
        success: true
      },
      observations: action.payload
    }
  }
  case types.GET_PATIENT_OBSERVATIONS_REJECTED: {
    return {
      ...state,
      getObservations: {
        ...state.getObservations,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_PATIENT_MEDICATIONS_REQUESTED: {
    const patient = state.patient
    return {
      ...state,
      userFriendlyStatus: `Retrieving medications for ${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`,
      getMedications: {
        loading: true,
        error: false,
        success: false
      }
    }
  }
  case types.GET_PATIENT_MEDICATIONS_FULFILLED: {
    const patient = state.patient
    return {
      ...state,
      userFriendlyStatus: `Found observations for ${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`,
      getMedications: {
        ...state.getMedications,
        loading: false,
        success: true
      },
      medications: action.payload
    }
  }
  case types.GET_PATIENT_MEDICATIONS_REJECTED: {
    return {
      ...state,
      getMedications: {
        ...state.getMedications,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.START_ENCOUNTER_OVER_REQUESTED: {
    return {
      ...state,
      userFriendlyStatus: 'Starting Lupus Advisor session over...',
      startEncounterOver: {
        loading: true,
        success: false,
        error: false,
        data: []
      }
    }
  }
  case types.START_ENCOUNTER_OVER_FULFILLED: {
    return {
      ...state,
      startEncounterOver: {
        ...state.startEncounterOver,
        loading: false,
        success: true,
        data: action.payload
      }
    }
  }
  case types.START_ENCOUNTER_OVER_REJECTED: {
    return {
      ...state,
      startEncounterOver: {
        ...state.startEncounterOver,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.UPDATE_ENCOUNTER_STATUS: {
    return {
      ...state
      // encounter: {
      //   ...state.encounter,
      //   status: action.payload
      // }
    }
  }
  case types.SET_PATIENT_DATA: {
    const { observations, medications, conditions } = action.payload
    return {
      ...state,
      observations,
      medications,
      conditions
    }
  }
  case types.RESET_PATIENT_REQUESTED: {
    return {
      ...state,
      reset: {
        loading: true,
        error: false,
        success: false
      }
    }
  }
  case types.RESET_PATIENT_FULFILLED: {
    return {
      ...state,
      reset: {
        ...state.reset,
        loading: false,
        success: true
      }
    }
  }
  case types.RESET_PATIENT_REJECTED: {
    return {
      ...state,
      reset: {
        ...state.reset,
        loading: false,
        error: action.payload
      }
    }
  }
  default:
    return state
  }
}

export default patientReducer
